import {useState} from "react";

const useCharacterCount = (maxCharLimit: any = null) => {
    //== How many character left
    const [characterCount, setCharacterCount] = useState<any>(maxCharLimit);
    const [inputPopup, setInputPopup] = useState<boolean>(false);

    const charCountHandler = (event: any) => {
        let maxCharLeft = maxCharLimit;
        let len = event.target.value.length;
        if (len > maxCharLeft) {
            return false;
        } else if (len >= 0) {
            setCharacterCount((maxCharLeft - len));
        } else {
            return characterCount;
        }

        event.target.value !== '' ? setInputPopup(true) : setInputPopup(false);
    }

    return [characterCount, inputPopup, charCountHandler];
}

export default useCharacterCount;